import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Feribot City Service
 * Şehir bazlı feribot API'leri için servis
 */
export const ferryCityService = {
  /**
   * Şehrin en ucuz rotalarını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CitySlug": "istanbul",
   *   "CurrencyCode": "TRY"
   * }
   */
  getCheapestRoutes: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.city.getCheapestRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehir bilgilerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CitySlug": "istanbul",
   *   "CurrencyCode": "TRY"
   * }
   */
  getCityInfo: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.city.getCityInfo,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehrin popüler firmalarını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CitySlug": "istanbul"
   * }
   */
  getPopularCompanies: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.city.getPopularCompanies,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler şehirleri getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getPopulars: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.city.getPopulars,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehir hakkında bilgileri getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CitySlug": "istanbul",
   *   "CurrencyCode": "TRY"
   * }
   */
  getCityAbout: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.city.getCityAbout,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehir sık sorulan sorularını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  getCitySss: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.ferry.city.getCitySss,
      payload,
      headers,
      hasErrorHandler,
    }),
};
